<template>
  <div class="col-md-6">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="elevation-2 radius-5 box mx-auto px-3 pb-3">
          <div class="row text-initial">
            <div class="col-12 text-center">
              <div
                class="col-12 font-weight-bold mt-2 card-title"
                style="min-height: 0;"
              >
                {{ data.name }}
              </div>
              <div class="col-12 text-center">
                <pdf
                  :src="
                    `https://assets.beereaders.com/assets/teacher/Activities/Activities_From_${data.category}_Years_${data.item}.pdf`
                  "
                  @loaded="$emit('itemLoaded', data.item)"
                ></pdf>
              </div>
            </div>
          </div>
          <div class="col-12 text-center d-flex justify-content-around pt-2">
            <a
              :href="
                `https://assets.beereaders.com/assets/teacher/Activities/Activities_From_${data.category}_Years_${data.item}.pdf`
              "
              target="_blank"
            >
              <button class="button primary py-2 my-0">
                Descargar
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "ActivityCard",
  props: ["data"],
  components: {
    pdf,
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.like-container {
  padding: 6px 7px;
  background: white;
  margin-left: auto;
  margin-top: -18px;
  width: 45px;
  position: absolute;
  right: 0;
  z-index: 2;
}

.like {
  font-size: 30px;
}

.icon {
  font-size: 60px;
}

p {
  font-size: 12px;
}

.message-box {
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: 0 0px 3px 3px rgba(64, 64, 64, 0.1);
  top: 0;
  right: -11px;
  padding: 0 9px;
  padding-top: 6px;
  border-radius: 3px;
}

.counter {
  position: absolute;
  top: -12px;
  right: -5px;
  background: var(--color-logo);
  width: 18px;
  height: 18px;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
}

.card-title {
  min-height: 50px;
}

.card-body {
  min-height: 180px;
}
</style>
